module.exports = __webpack_public_path__ + "static/img/6.54f6f08.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/2/eng/6.png
// module id = VHCn
// module chunks = 0